import { render, staticRenderFns } from "./SolicitudesBajasDetail.vue?vue&type=template&id=f752397c&scoped=true"
import script from "./SolicitudesBajasDetail.vue?vue&type=script&lang=js"
export * from "./SolicitudesBajasDetail.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesBajasDetail.vue?vue&type=style&index=0&id=f752397c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f752397c",
  null
  
)

export default component.exports